import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BeUtil, FeUtil } from '../../../../hezky-routes';
import { finalize } from 'rxjs';

@UntilDestroy({checkProperties: true})
@Component({
  selector: 'app-incident-modal',
  templateUrl: './incident-modal.component.html',
  styleUrl: './incident-modal.component.scss'
})
export class IncidentModalComponent implements OnInit {
  users: any[] = [];
  logs: any[] = [];
  loaders: { [key: string]: boolean } = {
    isIncidentLoading: false,
    isIncidentLogsLoading: false,
  };
  private previousAssignedTo: number | null = null;
  private previousAcknowledged: boolean | null = null;
  protected appId!: number;
  id!:string;

  constructor(
    @Inject(NZ_MODAL_DATA) protected readonly incident: any,
    protected readonly modalRef: NzModalRef,
    protected readonly feUtil: FeUtil,
    private readonly beUtil: BeUtil,
    private readonly cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.appId = this.feUtil.appId;
    this.id = this.appId === 2 ? this.incident.leg_id : this.incident.incident_id;
    this.incident['incident_id'] = this.appId === 2 ? 'T'+this.incident.trip_id+'L'+this.incident.leg_id : this.incident.incident_id;
    this.previousAssignedTo = this.incident.assigned_to ?? null;
    this.previousAcknowledged = this.incident.acknowledged ?? null;
    this.getIncidentLogs();
    this.getUsers();
  }

  private async getUsers(): Promise<void> {
    this.users = await this.beUtil.usersSvc.getUsersByLocAccess();
    const appId = this.feUtil.appId;
    const locId = appId == 1 ? this.incident?.location_id : this.incident.endLocation?.id;
    this.users = this.users.filter((user: any) => {
      const ids = user.location_ids?.split(',').map((id: string) => id.trim()) ?? [];
      return ids.includes(String(locId));
    });
  }

  private getIncidentLogs(): void {
    this.loaders['isIncidentLogsLoading'] = true;
    let id = this.feUtil.appId === 2 ? this.incident.leg_id : this.incident.incident_id;
    this.beUtil.incidentSvc.getLogData(id)
      .pipe(untilDestroyed(this), finalize(() => this.loaders['isIncidentLogsLoading'] = false))
      .subscribe({
        next: ({ data }) => {
          this.logs = data;
        }
      })
  }

  protected handleAssignTo(user_id: number): void {
    const prevAssignedTo = this.previousAssignedTo;
    const username = this.users.find(u => u.user_id === user_id)?.username || 'Select User';
    const payload = {
      incident_id: this.id,
      assigned_to: user_id,
    };
    this.beUtil.incidentSvc.assignToHandler(payload, username, 'storage')
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (result: boolean) => {
          if (result) {
            this.incident.assigned_to = user_id;
          } else {
            this.incident.assigned_to = prevAssignedTo;
            this.cdr.detectChanges();
          }
        }
      });
  }

  protected handleAcknowledge(): void {
    const prevAcknowledged = this.previousAcknowledged;
    this.beUtil.incidentSvc.acknowledgeIncidentHandler(this.id).subscribe({
      next: (result: boolean) => {
        if (result) {
          this.incident.acknowledged = true;
          this.getIncidentLogs();
        } else {
          this.incident.acknowledged = prevAcknowledged;
          this.cdr.detectChanges();
        }
      }
    });
  }
}
